interface ManageFeedsIconProps {
  size?: number;
}

// Checklist glyph for the "Manage my feeds" page - rows with checkmarks, echoing
// the selection checkboxes on that page. Deliberately distinct from the hamburger
// (three plain lines) used for menus.
const ManageFeedsIcon: React.FC<ManageFeedsIconProps> = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 6.5l1.7 1.7L8 4.7" />
      <line x1="12" y1="6.5" x2="21" y2="6.5" />
      <path d="M3 12l1.7 1.7L8 10.2" />
      <line x1="12" y1="12" x2="21" y2="12" />
      <path d="M3 17.5l1.7 1.7L8 15.7" />
      <line x1="12" y1="17.5" x2="21" y2="17.5" />
    </svg>
  );
};

export default ManageFeedsIcon;
